import { dataLayerCookieConsentUpdate } from './data-layer';

/**
 * @param {string} advertisingConsent
 * @param {string} performanceConsent
 */
export function updateConsent(advertisingConsent, performanceConsent) {
  const consentValues = {
    ad_user_data: advertisingConsent,
    ad_personalization: advertisingConsent,
    ad_storage: advertisingConsent,
    analytics_storage: performanceConsent,
  };
  const microsoftConsent = {
    ad_storage: advertisingConsent,
  };
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('consent', 'update', consentValues);
    dataLayerCookieConsentUpdate();
  }
  if (typeof window !== 'undefined' && window.uetq) {
    window.uetq.push('consent', 'update', microsoftConsent);
  }
  localStorage.setItem('advertisingConsent', JSON.stringify(consentValues));
  localStorage.setItem(
    'performanceConsent',
    JSON.stringify({ analytics_storage: performanceConsent })
  );
}
